import { createRequestActions } from "common/helpers/action";

export const initCpCompanySelect = createRequestActions("CP.COMPANY.SEARCH_F.INIT");
export const searchCpCompanySelect = createRequestActions("CP.COMPANY.SEARCH_F.SEARCH");
